export default __webpack_public_path__ + "assets/images/callback-autumn-a111cf98.png";